if (!customElements.get('prs-root')) {
  customElements.define('prs-root', class PrsRoot extends HTMLElement {
    constructor() {
      super();
      this.cartDrawerElement = document.querySelector('cart-drawer');
      this.addToCartButtonElement = this.querySelector('.prs-add-all-btn');
      this.addToCartButtonElement && this.addToCartButtonElement.addEventListener('click', this.handleButtonClick.bind(this));
    }

    connectedCallback() {
      this.resetScroll();
      window.addEventListener('load', this.resetScroll.bind(this));
      window.addEventListener('pageshow', this.resetScroll.bind(this));
    }

    resetScroll() {
      this.querySelectorAll('.prs-grid, .prs-pages').forEach((el) => {
        el.scrollLeft = 0;
      });
    }

    handleButtonClick(event) {
      event.preventDefault();
      this.lastClickedElement = event.submitter || event.currentTarget;

      const products = this.querySelectorAll('prs-variant-selector');
      const items = {
        items: [...products].map((product) => ({
          id: product.querySelector('[name=id]').value,
          quantity: product.querySelector('quantity-input') ? Number(product.querySelector('quantity-input').input.value) : 1,
        })),
      };

      if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
        FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...items } });
        return;
      }

      this.showErrorMessage();
      this.toggleButtonLoading(true);

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      const body = JSON.stringify({ ...items, sections: sectionsToBundle, section_url: window.pathname });

      fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            this.showErrorMessage(parsedState.description);
            return;
          }
          const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
          cartJson['sections'] = parsedState['sections'];
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
        })
        .catch((e) => console.error(e))
        .finally(() => this.toggleButtonLoading(false));
    }

    showErrorMessage(errorMessage = false) {
      this.errorMessageElement = this.errorMessageElement || this.querySelector('.product-form__error-message');
      if (this.errorMessageElement) {
        this.errorMessageElement.hidden = !errorMessage;
        if (errorMessage) this.errorMessageElement.textContent = errorMessage;
      }
    }

    toggleButtonLoading(status) {
      this.addToCartButtonElement.classList.toggle('btn--loading', status);
      this.addToCartButtonElement.toggleAttribute('disabled', status);
    }
  });
}

if (!customElements.get('prs-variant-selector')) {
  customElements.define('prs-variant-selector', class PrsVariantSelector extends HTMLElement {
    get priceElement() { return this.querySelector('.f-price'); }
    get variantSelect() { return this.querySelector('select'); }
    get productHandle() { return this.dataset.productHandle; }
    get sectionId() { return this.closest('prs-root').dataset.sectionId; }
    get blockId() { return this.dataset.blockId; }
    get rootUrl() { return window.Shopify.routes.root; }

    connectedCallback() {
      this.mainImage = this.querySelector('.product-card__image--main');
      this.variantSelect && this.variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      const variantSelect = event.target;
      const optionIds = variantSelect.options[variantSelect.selectedIndex].dataset.optionsId;
      this.updatePrice(variantSelect);

      fetch(`${this.rootUrl}products/${this.productHandle}/?section_id=${this.sectionId}&option_values=${optionIds}`)
        .then((r) => r.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectedVariantMedia = html.querySelector(`.product-bundle-card[data-block-id=${this.blockId}] .selected-variant-media`);
          if (selectedVariantMedia && this.mainImage) {
            this.mainImage.innerHTML = selectedVariantMedia.innerHTML;
          }
        })
        .catch((error) => console.error(error));
    }

    updatePrice(variantSelect) {
      const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
      const price = parseInt(selectedVariant.dataset.price || 0);
      const compareAtPrice = parseInt(selectedVariant.dataset.compare_at_price || 0);

      const regularPriceElement = this.querySelector('.f-price__regular .f-price-item--regular');
      if (regularPriceElement) regularPriceElement.innerHTML = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);

      const saleRegular = this.querySelector('.f-price__sale .f-price-item--regular');
      const saleItem = this.querySelector('.f-price__sale .f-price-item--sale');
      if (saleRegular) saleRegular.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compareAtPrice, FoxTheme.settings.moneyFormat)}</s>`;
      if (saleItem) saleItem.innerHTML = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);
    }
  });
}

if (!customElements.get('prs-hotspot')) {
  customElements.define('prs-hotspot', class PrsHotspot extends HTMLElement {
    get index() { return parseInt(this.dataset.index); }
    get root() { return this.closest('prs-root'); }
    get tile() { return this.root.querySelector(`.prs-tile[data-index="${this.index}"]`); }
    get pager() { return this.root.querySelector('prs-pager'); }

    connectedCallback() {
      this.addEventListener('mouseenter', this.activate.bind(this));
      this.addEventListener('mouseleave', this.deactivate.bind(this));
      this.addEventListener('click', this.activate.bind(this));
    }

    activate() {
      this.classList.add('is-active');
      this.root.classList.add('is-hover');
      if (this.pager) this.pager.goToIndex(this.index);
      const tile = this.tile;
      if (tile) {
        tile.classList.add('is-selected');
        const isStackedLayout = window.matchMedia('(max-width: 1569px)').matches;
        if (isStackedLayout) {
          setTimeout(() => {
            tile.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'center' });
          }, 50);
        }
      }
    }

    deactivate() {
      this.classList.remove('is-active');
      this.root.classList.remove('is-hover');
      this.root.querySelectorAll('.prs-tile.is-selected').forEach((el) => el.classList.remove('is-selected'));
    }
  });
}

if (!customElements.get('prs-pager')) {
  customElements.define('prs-pager', class PrsPager extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.prs-track');
      this.pages = Array.from(this.querySelectorAll('.prs-page'));
      this.currentPage = 0;
      this.prevBtn = this.closest('.prs-content-col').querySelector('.prs-prev');
      this.nextBtn = this.closest('.prs-content-col').querySelector('.prs-next');
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.goToPage(this.currentPage - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.goToPage(this.currentPage + 1));
      this.updateView();
    }

    goToIndex(index) {
      this.goToPage(Math.floor(index / 4));
    }

    goToPage(pageIndex) {
      if (pageIndex < 0 || pageIndex >= this.pages.length) return;
      this.currentPage = pageIndex;
      this.updateView();
    }

    updateView() {
      if (this.track) {
        this.track.style.transform = `translateX(-${this.currentPage * 100}%)`;
      }
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.currentPage === 0);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.currentPage === this.pages.length - 1);
    }
  });
}